import { onMounted, watch } from 'vue'
export default useToggleLayers
/**
 * @typedef {Object} LayerConfig
 * @property {String} id - the layer id to be used for future reference
 * @property {Object} source - a mapbox source options object
 * @property {Object} style - an object with type, paint and layout mapbox style properties
 * @property {string} before - The ID of an existing layer to insert the new layer before
 */

/**
 * reactively show and hide layers
 * @param  {Object} mapRef a gl-map component vue ref
 * @param  {Array.<LayerConfig>} layersConfig an array of layer configuration objects
 * @param  {Array.<String>} visibleLayersRef a ref to an array of currently visible layer ids (from layers[].id )
 * @alias module:map-composable
 */
function useToggleLayers(mapRef, layersConfig, visibleLayersRef) {
  onMounted(() => {
    const map = mapRef.value.map
    map.on('load', () => {
      layersConfig.forEach(({ id, source, style, before }) => {
        const sourceId = `${id}-source`
        const layerId = id
        map.addSource(sourceId, source)
        map.addLayer(
          {
            ...style,
            id: layerId,
            source: sourceId,
            layout: {
              ...style.layout,
              visibility: visibleLayersRef.value.includes(id)
                ? 'visible'
                : 'none'
            }
          },
          before
        )
      })
    })
  })
  watch(visibleLayersRef, (newVal, oldVal) => {
    const toShow = newVal.filter(l => !oldVal.includes(l))
    const toHide = oldVal.filter(l => !newVal.includes(l))
    toShow.forEach(l => {
      mapRef.value.map.setLayoutProperty(l, 'visibility', 'visible')
    })
    toHide.forEach(l => {
      mapRef.value.map.setLayoutProperty(l, 'visibility', 'none')
    })
  })
  return {
    mapRef
  }
}
